var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCourseArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 24,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5C19 16.366 15.866 19.5 12 19.5C8.13401 19.5 5 16.366 5 12.5C5 8.63401 8.13401 5.5 12 5.5C15.866 5.5 19 8.63401 19 12.5Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0832L9.12672 11.1112C8.98335 10.9629 8.7509 10.9629 8.60752 11.1112C8.46416 11.2595 8.46416 11.5 8.60752 11.6483L11.7404 14.8888C11.8838 15.0371 12.1162 15.0371 12.2596 14.8888L15.3925 11.6483C15.4642 11.5741 15.5 11.4769 15.5 11.3798C15.5 11.2826 15.4642 11.1854 15.3925 11.1112C15.2491 10.9629 15.0166 10.9629 14.8733 11.1112L12 14.0832Z",
    fill: "#999999",
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCourseArrowIcon);
export default __webpack_public_path__ + "static/media/ic_course_arrow_icon.5eb339f732fa3f3742b9f9f8d2ce7759.svg";
export { ForwardRef as ReactComponent };